module.exports = __webpack_public_path__ + "assets/img/586c5387994f2c8f3f36a5ed629e5fbe.png";